import { Link } from "react-router-dom";
import { StatusChip } from "../../components/ui";
import { offerDeadline, offerDetailPath, offerReward, offerTarget } from "./offerHelpers";

/** A clamped preview of one offer; the full text lives on the offer's own page. */
const OfferCard = ({ offer }) => {
  const reward = offerReward(offer);
  const target = offerTarget(offer);
  const closes = offerDeadline(offer);
  const image = (offer.imageUrls || [])[0];
  const ended = Boolean(offer.ended);

  return (
    <li
      className={`rounded-xl border p-3.5 ${
        ended ? "border-slate-200 bg-slate-50" : "border-amber-200 bg-amber-50/60"
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-900 m-0 break-words line-clamp-2">
            {offer.title}
          </p>
          {target ? (
            <p className="text-xs text-slate-600 m-0 mt-0.5">
              {reward ? `${reward} for ${target}` : target}
            </p>
          ) : null}
        </div>
        {ended ? (
          <StatusChip>{closes ? `Ended ${closes}` : "Ended"}</StatusChip>
        ) : closes ? (
          <StatusChip tone="amber">Until {closes}</StatusChip>
        ) : null}
      </div>
      {image ? (
        <img
          src={image}
          alt=""
          className={`mt-3 w-full rounded-lg object-cover ${ended ? "opacity-70" : ""}`}
          style={{ maxHeight: 120 }}
        />
      ) : null}
      {offer.description ? (
        <p className="text-xs text-slate-600 m-0 mt-2 whitespace-pre-line break-words line-clamp-3">
          {offer.description}
        </p>
      ) : null}
      <Link
        to={offerDetailPath(offer)}
        className="mt-2 inline-block text-xs font-semibold text-teal-700 no-underline hover:text-teal-800"
      >
        View offer details →
      </Link>
    </li>
  );
};

export default OfferCard;
